export const springPresets = {
  default: { type: "spring" as const, bounce: 0.2, duration: 0.4 },
  gentle: { type: "spring" as const, bounce: 0.1, duration: 0.5 },
  snappy: { type: "spring" as const, bounce: 0.3, duration: 0.3 },
  none: { duration: 0.2, ease: [0.25, 0.1, 0.25, 1] as const },
} as const;

export const fadeInUp = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
  transition: springPresets.default,
};

export const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: springPresets.none,
};

export const staggerContainer = {
  animate: { transition: { staggerChildren: 0.05 } },
};

export const staggerItem = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  transition: springPresets.gentle,
};
